var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isData)?_c('div',{staticClass:"m-5 shadow-md bg-white p-5 rounded"},[_c('a-table',{staticClass:"shadow-md p-5",attrs:{"columns":_vm.columns,"data-source":_vm.data,"showHeader":false,"pagination":false}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }